import { useCallback, useEffect, useState } from 'react';

export interface ModalProps {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const useModal = (): ModalProps => {
  const [open, setIsOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : 'auto';
  }, [open]);

  const handleOpenModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') handleCloseModal();
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  return {
    open,
    onOpen: handleOpenModal,
    onClose: handleCloseModal,
  };
};
